import { DefaultTheme } from 'styled-components';

export const dark: DefaultTheme = {
  colors: {
    background: '#252525',
    text: '#fff',
    line: '#666',
    gistRed: '#DF3127',
    gistGreen: 'rgb(47, 86, 50)',
    focus: '#333',
  },
};

export const light: DefaultTheme = {
  colors: {
    background: '#fff',
    text: '#000',
    line: '#aaa',
    gistRed: '#DF3127',
    gistGreen: 'rgb(47, 86, 50)',
    focus: '#eee',
  },
};
